/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';
import {
    Card, CardImg, CardText, CardBody,
    CardTitle, Breadcrumb, BreadcrumbItem, Button, Modal, ModalHeader, ModalBody, Col, Row, Label
} from 'reactstrap';
import { Control, LocalForm, Errors } from 'react-redux-form';
import jumpersStore from '../../../stores/jumpers-store';

import { components } from 'react-select';
import AsyncSelect from 'react-select/lib/Async';

import loadsStore from '../../../stores/loads-store';
import JmpModal from './customModal';
import Fuse from "fuse.js";
import ReactDOM from 'react-dom';
import { ClipLoader } from 'react-spinners';

const customStyles = {
    control: base => ({
        ...base,
        minHeight: 30
    }),
    menu: (provided, state) => ({
        ...provided,
        borderBottom: "1px dotted pink",
        color: state.isSelected ? "red" : "blue",
        padding: 20,
        height: 730
    }),
    menuList: (provided, state) => ({
        ...provided,
        borderBottom: "1px dotted pink",
        padding: 20,
        minHeight: 700
    })
};

class StaffCheckin extends Component {

    constructor(props) {

        super(props);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTransferCredit= this.handleTransferCredit.bind(this);
        this.toggleError= this.toggleError.bind(this);
        // this.updateGear = this.updateGear.bind(this);
        // this.MultiValueLabel = this.MultiValueLabel.bind(this);

        this.state = {
            isModalOpen: false,
            jumperOptions: [],
            adminDefaultOptions: [],
            ErrorMessage: '',
            placement: 'bottom',
            errors: {},
            fromId: '',
            toId: '',
            isloading:false,
            errorOpen:false,
            isCheckedIn: false,
            tiaspi: false,
            video: false
        };

        this.handleJumpersLoaded = this.handleJumpersLoaded.bind(this);

        this.jumperEvents = [
            { name: jumpersStore.getEventPrefix('jumpersLoaded'), func: this.handleJumpersLoaded },
            { name: jumpersStore.getEventPrefix('creditTransferEvent'), func: this.handleTransferCredit }
        ];
    }


    toggleModal() {
        if(!this.state.isModalOpen){
          this.setState({
            video: false,
            tiaspi: false
          })
        }
        this.setState({
            isModalOpen: !this.state.isModalOpen,
        });
        // this.gearIds.length = 0;
    }

    handleSubmit = (newValue) => {
        var payLoad = {}
        payLoad.staffId = this.state.toId;
        payLoad.price = newValue.amount;
        if(newValue.memo !== "")
        {
            payLoad.memo= newValue.memo;
        }
        if (this.state.toId != undefined && !this.state.isCheckedIn ) {
            jumpersStore.Checkin(this.state.toId, this.state.tiaspi, this.state.video)
            .then(t => {
              this.toggleModal();
            })
        }
        else if(this.state.toId != undefined && this.state.isCheckedIn ){
            jumpersStore.Checkout(this.state.toId)
            .then(t => {
              this.toggleModal();
            })
        }
    };

    componentDidMount = () => {
        //console.log('in components did mount accounts');
        this.jumperEvents.forEach((evnt) => jumpersStore.on(evnt.name, evnt.func));

        var options = jumpersStore.getStaffOptions();

        this.setState({ jumperOptions: options, adminDefaultOptions: options.slice(0, 50) });
    }

    componentWillUnmount = () => {
        this.jumperEvents.forEach((evnt) => jumpersStore.removeListener(evnt.name, evnt.func));
    }

    componentWillReceiveProps()
    {
        this.setState({
            fromId: this.props.jumperId,
        })
    }

    filterJumpers = (inputValue: string, jumperOptions) => {
        //console.log("in filterJumpers");
        if (inputValue) {
            //console.log(inputValue);
            var filteredOptions = jumperOptions.filter(i =>
                i.label.toLowerCase().includes(inputValue.toLowerCase()));
            ////console.log(filteredOptions);
            if (filteredOptions.length > 30) return filteredOptions = filteredOptions.slice(0, 30);
            else return filteredOptions;
        }
        //console.log('no inputValue');
        return jumperOptions.slice(0, 30);
    };

    promiseOptions = (inputValue, jumperOptions) => {
        //console.log('in pomiseOptions');
        //console.log(this.inputValue);
        return new Promise(resolve => {
            resolve(this.filterJumpers(this.inputValue, jumperOptions));
        });
    }

    handleInputChange = (newValue) => {
        //console.log('handleInputChange');

        //const inputValue = newValue.replace(/\W/g, '');
        ////console.log(inputValue);

        //this.promiseOptions(newValue, jumperOptions);
        this.inputValue = newValue;
        //return inputValue;
    };

    handleFromSelect = (val) => {
        //console.log('in handleSelect');
        if (val.value !== undefined) {
            ////alert(JSON.stringify(val.value));
            // this.onJumperChanged(val.value);
            // jumpersStore.getDailyActivity(val.value._id);
            this.setState({
                fromId: val.value._id
            });
            //console.log(JSON.stringify(val.value));
        }
    }

    handleToSelect = (val) => {
        //console.log('in handleSelect');
        if (val.value !== undefined) {
            ////alert(JSON.stringify(val.value));
            // this.onJumperChanged(val.value);
            var checkedInStatus = jumpersStore.getCheckedInStatus(val.value._id);
            this.setState({
                toId: val.value._id,
                isCheckedIn : checkedInStatus
            });
            //console.log(JSON.stringify(val.value));
        }
    }

    Option = (props) => {
        //console.log(props);
        return (
            <div className="row">
                <div className="col-12">
                    <components.Option {...props} />
                </div>
            </div>
        );
    }

    handleJumpersLoaded(jumperOptions) {
        //console.log('in handle jumpers loaded in accounts');
        var options = jumpersStore.getStaffOptions();

        var adminDefaultOptions = options.slice(0, 50);
        //alert('handle Jumpers Loaded');
        this.setState({
            jumperOptions: options,
            adminDefaultOptions: adminDefaultOptions
        });
    }

    toggleError() {
        this.setState({
            errorOpen:!this.state.errorOpen
        });
    }

    handleTransferCredit(data)
    {
        if(data === true)
        {
            this.setState({
                isloading:false,
                isModalOpen:false
            })
        }
        else
        {
            this.setState({
                isloading:false,
                isModalOpen:false,
                errorOpen:true
            })
            //console.log('fail');
        }
    }

    handleInput = (event, key) => {
        var cache = { ...this.state };
        cache[key] = event.target.value;
        this.setState({ ...cache }, () => {
            this.handleValidation(key);
        });
        // if (!this.state.errors.length)
        //     tandemData.updateFormWithIndex(cache, this.props.index - 1);
    };

    handleValidation(name) {
        let fields = this.state;
        let errors = fields.errors;
        if (fields[name] === '') errors[name] = "This field is required";
        else if (name === 'amount' && !fields[name].match(/((\d+)(\.\d{2}))$/)) errors[name] = "Amount should be enter in two decimal places.";
        else errors[name] = "";
        this.setState({ errors: errors });
    }

    onTIASPIclick = value => {
  		console.log('on first out cllick');
  		console.log(value.target);
  		if (value.target.checked)
  			this.setState({ tiaspi: true });
  		else
  			this.setState({ tiaspi: false });
  	}

    onVideoClick = value => {
      console.log('on first out cllick');
      console.log(value.target);
      if (value.target.checked)
        this.setState({ video: true });
      else
        this.setState({ video: false });
    }


    render() {
        var screenWidth = window.innerWidth;
        var defaultValue= '';
        if(this.state.fromId && this.state.jumperOptions.length>0)
        {
          var defaultValue= this.state.jumperOptions.filter(x=>x.value._id === this.state.fromId)[0].label;
        }
        var modalMargin = '25%';
        if(screenWidth >= 1920 )
        {
            modalMargin = '65%';
        }

        const override = `
        display: block;
        margin: 0 auto;
        border-color: red;
        `;

        return (
            <React.Fragment>
                <JmpModal
                    isModalOpen={this.state.isModalOpen}
                    title={`Staff Checkin`}
                >
                      <div className='complete-loading'>
                        <ClipLoader
                            css={override}
                            sizeUnit={"px"}
                            size={35}
                            color={'#fff'}
                            loading={this.state.isloading}
                        />
                    </div>


                    <LocalForm onSubmit={(values) => this.handleSubmit(values)}>


                        <Row className="form-group">
                            <Label htmlFor="To" md={3}>Staff Search: </Label>
                            <Col md={9}>
                                <AsyncSelect loadOptions={(newValue) => this.promiseOptions(newValue, this.state.jumperOptions)}
                                    styles={customStyles} onInputChange={(val) => this.handleInputChange(val)}
                                    defaultOptions={this.state.adminDefaultOptions} onChange={(val) => this.handleToSelect(val)} components={{ Option: this.Option }}
                                />
                            </Col>
                        </Row>
                        {loadsStore.getOvSeparateCheckinSetting()?
                          <React.Fragment>
                            <Row className="form-group" style={{ paddingLeft: '8px', paddingRight: '7px' }}>
                              <Col md={12}>
                                TI/ASPI  <Control.checkbox model=".tiaspi" name="tiaspi" onChange={(value) => { this.onTIASPIclick(value) }} />
                              </Col>
                            </Row>

                            <Row className="form-group" style={{ paddingLeft: '8px', paddingRight: '7px' }}>
                              <Col md={12}>
                                VIDEO  <Control.checkbox model=".video" name="video" onChange={(value) => { this.onVideoClick(value) }} />
                              </Col>
                            </Row>
                          </React.Fragment>:null
                        }


                        <Row className="form-group">
                            <Col md={{ size: 10 }}>
                                <button className="btn btn-bg lightColor createButton" type="submit" style={{fontColor: "#ffffff"}} >{this.state.isCheckedIn?"Checkout":"Checkin"}</button>
                                <button onClick={(e) => { e.preventDefault(); this.toggleModal(); }} className="btn btn-link">Cancel</button>
                            </Col>
                        </Row>



                    </LocalForm>
                </JmpModal>
                <Modal isOpen={this.state.errorOpen} toggle={this.toggleError} className={this.props.className}>
                    <ModalHeader toggle={this.toggleError} className="error-jumperHeader">
                       Error
                    </ModalHeader>
                    <ModalBody>
                        <p style={{ color: 'red', fontSize: '20px', marginLeft: '1%' }}>Something Wrong happened while Transfer Credits !</p>
                    </ModalBody>
                </Modal>
                <button  style={{  borderRadius: '1px',backgroundColor: '#A7F6FF',color: '#082764'}} onClick={this.toggleModal} type="submit" disabled={this.props.disabled}>
                    STAFF CHECK IN/OUT
                </button>
                {/* <button className="btn customButton rightButton" style={{ borderRadius: '4px',backgroundColor: '#A7F6FF',color: '#082764',marginTop:'65%',marginBottom:'8px' }} onClick={this.toggleModal}>
                    TRANSFER CREDIT
                </button> */}
            </React.Fragment>
        );
    }
}

export default StaffCheckin
